import RegisterStep from "./RegisterStep";

const HandleRenderDiv = ({ pagename, startStep, onClose }) => {
  return (
    <RegisterStep
      initialStep={startStep}
      onClose={onClose}
    />
  );
};

export default HandleRenderDiv;
